export default function BonesIcon({ className }: { className?: string }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <line x1="6" y1="14" x2="14" y2="6" stroke="currentColor" strokeWidth="1.35" strokeLinecap="round" />
      <circle cx="6" cy="14" r="2.64" fill="currentColor" />
      <circle cx="14" cy="6" r="2.64" fill="currentColor" />
    </svg>
  );
}
